import { debounce } from "lodash";
import { dataLayerPush } from "./data-layer-push";

const TRACKING_DELAY_MS = 1000;
let SEARCH_CACHE: string | undefined;

/**
 * Only send a tracking event after the user stopped typing
 *
 * This is to prevent tracking stuff like:
 * "Aus", "Ausbi", "Ausbildung" all separately
 */
const debouncedTracking = debounce((searchQuery: string) => {
  dataLayerPush({
    event: "jobboard_search_query_used",
    searchQuery: searchQuery.trim(),
  });
}, TRACKING_DELAY_MS);

export function trackingOnSearchQueryChange(newSearchQuery: string | null) {
  if (!newSearchQuery || SEARCH_CACHE === newSearchQuery) {
    return;
  }

  if (newSearchQuery.length < 3) {
    return;
  }

  debouncedTracking(newSearchQuery);

  SEARCH_CACHE = newSearchQuery;
}
